module.exports = __webpack_public_path__ + "static/media/tour.48d9aea4.svg";